import React, { useEffect, useMemo } from 'react';
import { useFormikContext } from 'formik';

import { FormikSearchSelect } from 'components/UiKit/FormikFields';

import useCropData from 'hooks/useCropData';

// Each Formik update would validate on its own against the values from before
// this selection, and the last to finish wins, so a name filled in from the
// crop kept its "required" error. Update without validating, then validate
// once with the complete new values.
export const onSelect = (
  { key, value },
  { values, touched, setFieldValue, setFieldTouched, validateForm }
) => {
  let isCropTouched = !!touched.crop;
  const nextValues = { ...values, crop: key };
  setFieldValue('crop', key, false);

  if (key !== values.crop) {
    isCropTouched = true;
  }

  if (isCropTouched) {
    setFieldValue('name', value, false);
    nextValues.name = value;
  }

  setFieldTouched('crop', isCropTouched, false);
  validateForm?.(nextValues);
};

const CropZoneCropSelect = () => {
  const { crops, fetchCrops } = useCropData();

  const formikContext = useFormikContext();

  const cropItems = useMemo(
    () =>
      crops?.map(crop => ({
        key: crop.id,
        value: crop.name
      })) || [],
    [crops]
  );

  const onCropSelect = ({ key, value }) => {
    onSelect({ key, value }, formikContext);
  };

  useEffect(() => {
    fetchCrops();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formikContext.values.crop]);

  return (
    <div className="-mt-8">
      <label
        htmlFor="crop"
        className="text-neutral-600 text-sm inline-block mb-1 "
      >
        Crop*
      </label>
      <FormikSearchSelect
        name="crop"
        items={cropItems}
        placeholder="Select Crop"
        onSelect={onCropSelect}
      />
    </div>
  );
};

export default CropZoneCropSelect;
